export default "__VITE_ASSET__31d20408__"